import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";
import { fieldName } from "./styles_vanilla.css";

export type ProfileFieldProps = {
  label: string;
  value: React.ReactNode;
  className?: string;
};

export const ProfileField: React.FC<ProfileFieldProps> = ({ label, value, className }) => {
  const isMultiLine = label.startsWith("Address");

  return (
    <Flex alignItems={isMultiLine ? "flex-start" : "center"} gap={Sizes.MD}>
      <Text variant="strong-md" className={fieldName}>
        {label}
      </Text>
      <Flex className={className}>{value}</Flex>
    </Flex>
  );
};
